import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';

import { useTranslation } from "react-i18next";
import moment from "moment";
import Swal from "sweetalert2";

import {
    Button, Input, Label,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Form
} from "reactstrap";

import FilesCustom from 'components/FilesCustom';
import ShowDetails from 'components/ShowDetails';
import Historical from 'components/Historical';

import CNavbar from 'components/CNavbar';

import * as commonFunc from 'scripts/common';
import CDataTable, { showDtPrevID, showDtSelID, showDtNextID, setDtNoSelect } from "components/CDataTable";

import { withRouter } from 'components/withRouter';

import { saveTicket } from "views/pages/ManageTickets";

class ManageMaterials extends Component {
    static displayName = ManageMaterials.name;

    static materialModels;
    static refreshCb;
    static modalRoot;

    static loadReportCb;

    constructor(props) {
        super(props);

        this.materialGen = React.createRef(null);

        var defMatCategoryGroupKey = "";
        var defMatPageModels = "";
        if (props.searchParams) {
            defMatCategoryGroupKey = props.searchParams.get("categoryGroupKey") || "";
            defMatPageModels = props.searchParams.get("pageModels") || "";
        }

        this.state = {
            materials: [], curMaterial: null, curMaterialId: 0, status: [], defaultStatus: 4000, curStatus: 4000/*, historicalReports: true*/, loading: true, dataStamp: 0, activeTab: "1",
            title: props.i18nManager.t("material.noSelected"), editionMode: false, categoryGroupKey: defMatCategoryGroupKey, pageModels: defMatPageModels
        };
    }

    componentDidMount() {
        //console.debug("MOUNT");

        var context = this;

        if (this.props.updateUser) this.props.updateUser(function (curUser) {

            commonFunc.getMethod("../api/material/GetMaterialModels", { id: -1 }).then((responseModels) => {
                var dataModels = responseModels.data;
                if (dataModels.isSuccess) {

                    context.materialModels = {};
                    dataModels.result.models.forEach((model) => {
                        context.materialModels[model.extID] = JSON.parse(model.value);
                    });

                    //context.materialModels["CONTACTS"] = {};
                    //context.materialModels["DT_CTCS"] = {};
                    //context.materialModels["DLG_CONTACT"] = {};
                    


                    //Chargement via url
                    var defMaterialLoadId = 0;
                    var defMaterialActionId = 0;
                    if (context.props.searchParams) {
                        defMaterialLoadId = parseInt(context.props.searchParams.get("materialId")) || 0;
                        defMaterialActionId = parseInt(context.props.searchParams.get("actionId")) || 0;
                    }
                    if (defMaterialLoadId > 0) {
                        var defMaterialStatusId = parseInt(context.props.searchParams.get("statusId")) || 4000;

                        context.loadStatusBtnGrp(defMaterialStatusId);

                        context.getMaterials(defMaterialStatusId, false, function () {
                            if (context) {
                                context.loadReportCb = () => {
                                    if (defMaterialActionId) context.switchTab(defMaterialActionId.toString());

                                    //setTimeout(function () {
                                    var element = document.querySelector('.tableContainer');
                                    const elementBottom = element.offsetTop + element.offsetHeight - 93;//marginTop - mainPanel/content
                                    context.props.getScroller().smoothScroll(elementBottom /*|| 1500*/);
                                    //}, 2000);
                                };
                            }
                            showDtSelID("tableMaterials", defMaterialLoadId);
                        });
                    } else {
                        context.loadStatusBtnGrp(4000);

                        context.getMaterials();

                        if (defMaterialActionId) context.switchTab(defMaterialActionId.toString());

                        /*if (defMaterialActionId == 1) {
                            $(".action-addReport:visible").click();
                        }*/
                    }

                } else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_failLoadModels") + " :<br>" + dataModels.errorMessage
                    });
                }
            });
        });

    }

    componentDidUpdate(prevProps, prevState) {
        //console.debug("UPDATE");
        if (/*prevState.historicalReports !== this.state.historicalReports || */prevState.curStatus !== this.state.curStatus || prevState.categoryGroupKey !== this.state.categoryGroupKey || prevState.pageModels !== this.state.pageModels) {
            this.getMaterials();
        }
        else {
            var defMatCategoryGroupKey = "";
            var defMatPageModels = "";
            if (this.props.searchParams) {
                defMatCategoryGroupKey = this.props.searchParams.get("categoryGroupKey") || "";
                defMatPageModels = this.props.searchParams.get("pageModels") || "";
            }

            if (this.state.categoryGroupKey !== defMatCategoryGroupKey || this.state.pageModels !== defMatPageModels) {
                this.setState({ categoryGroupKey: defMatCategoryGroupKey, pageModels: defMatPageModels, noTable: true });
            }
        }

        //Update Scroller Size
        if (prevState.isShowDetails && !this.state.isShowDetails) {
            if (this.props.getScroller) this.props.getScroller().update();
        }

        //Callback initCreateMaterial
        if (this.state.curMaterialId === 0 /*&& prevState.curMaterialId !== this.state.curMaterialId*/ && this.state.editionMode && !this.state.isShowDetails) {
            this.setState({ isShowDetails: true });
        }
        if (prevState.editionMode !== this.state.editionMode && this.dtFunctions && this.dtFunctions["tableMaterials"]) this.dtFunctions["tableMaterials"].setDisabled(this.state.editionMode);
    }

    componentWillUnmount() {
        //console.debug("unmount");
        if (this.modalRoot) {
            this.modalRoot.unmount(); 
            this.modalRoot = null;
        }
    }

    dtFunctionPanel(id, fctPanel) {
        if (!this.dtFunctions) this.dtFunctions = {};
        if (!this.dtFunctions[id]) this.dtFunctions[id] = {};
        this.dtFunctions[id] = fctPanel;
    }

    render() {
        var context = this;
        var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };

        var listCb = function () {
            if (context.refreshCb) {
                if (context.refreshCb && typeof (context.refreshCb) === "function") { context.refreshCb(); }
                context.refreshCb = null;
            }
        };

        //TODO : createdCell >> dépendance du contexte pour éxecution de la fonction
        //TEMP : doit dépendre d'une configuration (tout virer sauf createdCell et cbInitComplete)
        var dtConfig = {
            columnDefs: [
                {
                    createdCell: (td, cellData, rowData, row, col) => {
                        var currRoot = createRoot(td);
                        currRoot.render(<Button className='btn-icon btn-simple m-0' color="dark" size="sm" disabled={this.state.editionMode}
                            onClick={() => context.loadMaterial(rowData.idMaterial, rowData)} title={context.props.i18nManager.t("gal_show")} ><i className='fa fa-eye'></i></Button>);
                    }, "targets": "renderingShow"
                },
            ],
            dtOnSelect: function (dataSel) {
                var id = dataSel.idMaterial;
                if (parseInt(id) > 0) {
                    if (!context.state.editionMode) context.loadMaterial(id, dataSel);
                }
            },
            dtOnUnselect: function (dataSel) {
                if (!context.state.editionMode) context.loadMaterial();
            },
            dtOnDblClick: function (event) {
                /*var id = parseInt(getDtSelID("lstActs"));
                var currId = parseInt($(this).closest("tr").prop("id"));
                if (currId != id) {
                    scrollToId("detailAct");
                    showDtSelID("lstActs", currId);
                }
                else {
                    if (currId > 0) {
                        scrollToId("detailAct");
                    }
                }*/
            },
            cbInitComplete: function (cRootList) {
                //Swal.close();

                /*cRootList.map((prop, elem) => {
                    console.debug(elem);
                    if (elem.classList.contains("cneedroot")) {
                        var rootElem = createRoot(elem);
                        switch (elem.getAttribute("cneedroot")) {
                            case "forceLogout":
                                rootElem.render(<button className="btn btn-primary btn-icon" onClick={() => context.forceLogout('hey!')}><i className='fa fa-edit'></i></button>);
                                break;
                            default:
                                break;
                        }
                    }
                    return null;
                });*/

                //$("#report_select_filters").appendTo($(".dt-buttons").parent().parent());
                //$("#report_select_filters").removeClass("d-none").addClass("d-inline-block");

                //updateSidebar();

                listCb();
            },
            cbCustom: function () {
                listCb();
            }
        };


        var pageConfig;
        var tableConfig;
        switch (context.state.pageModels) {
            case "INFO":
                pageConfig = {
                    "objType": "model", "templates": [
                        { "title": "i18n:material.tabDetails", "objType": "template", "subType": "MATERIAL_INFO", "checkRights": { "entity": "MATERIAL", "rights": "R" } },
                        { "title": "i18n:material.tabContacts", "objType": "template", "subType": "CONTACTS", "checkRights": { "entity": "MATERIAL_CONTACTS", "rights": "L" } },
                        { "title": "i18n:material.tabDocs", "objType": "template", "subType": "FILES", "checkRights": { "entity": "MATERIAL_FILES", "rights": "L" } },
                        { "title": "i18n:material.tabFlows", "objType": "template", "subType": "FLOWS", "checkRights": { "entity": "MATERIAL_FLOWS", "rights": "L" } },
                        { "title": "i18n:material.add", "objType": "button", "subType": "ADD", "checkRights": { "entity": "MATERIAL", "rights": "C" } }
                    ]
                };
                tableConfig = "DT_INFOMATERIALS";
                break;
            default:
                pageConfig = {
                    "objType": "model", "templates": [
                        { "title": "i18n:material.tabDetails", "objType": "template", "subType": "MATERIAL", "checkRights": { "entity": "MATERIAL", "rights": "R" } },
                        { "title": "i18n:material.tabContacts", "objType": "template", "subType": "CONTACTS", "checkRights": { "entity": "MATERIAL_CONTACTS", "rights": "L" } },
                        { "title": "i18n:material.tabDocs", "objType": "template", "subType": "FILES", "checkRights": { "entity": "MATERIAL_FILES", "rights": "L" } },
                        { "title": "i18n:material.tabFlows", "objType": "template", "subType": "FLOWS", "checkRights": { "entity": "MATERIAL_FLOWS", "rights": "L" } },
                        { "title": "i18n:material.add", "objType": "button", "subType": "ADD", "checkRights": { "entity": "MATERIAL", "rights": "C" } }
                    ]
                };
                tableConfig = "DT_MATERIALS";
                break;
        }



        var getSysCpt = (template, index) => {
            var curUser = this.props.getUser();

            var srcRoles = curUser.roles;
            var haveCustomProfiles = curUser.roles.filter(role => role.startsWith("PRFL_"));
            srcRoles = haveCustomProfiles?.length ? haveCustomProfiles : srcRoles;
            var targetRoles = srcRoles ? srcRoles[0] : null;

            var materialModel;
            var srcModel;
            var resFilter = Object.keys(this.materialModels).filter((key) => {
                var model = this.materialModels[key];
                if (key === "MATERIAL" || key === ("MATERIAL_" + this.state.curMaterial?.categoryID)) {
                    if (model.siteID > 0 || (model.siteID === -1 && !srcModel)) {
                        srcModel = model;
                    }
                }

                return key === "MATERIAL_" + targetRoles || (key === ("MATERIAL_" + this.state.curMaterial?.categoryID + "_") + targetRoles);
            });
            if (resFilter?.length) {
                materialModel = this.materialModels[resFilter[0]];
            }
            else if (srcModel) {
                materialModel = srcModel;
            }
            else {
                materialModel = this.materialModels ? (this.materialModels["MATERIAL_" + this.state.curMaterial?.categoryID] || this.materialModels[template.subType]) : {};
            }

            var filesAltObj = {};
            if (context.filesType) filesAltObj.filesType = context.filesType;
            else filesAltObj.altFilesTypes = "../api/material/GetMaterialFilesType";

            var cptSysCollection = {
                "MATERIAL": <ShowDetails id={this.state.curMaterialId} type="material" genRef={this.materialGen} data={this.state.curMaterial} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={materialModel} modelsList={this.materialModels} loadElem={this.loadMaterial.bind(this)} saveElem={this.contextSaveMaterial.bind(this)} removeElem={this.removeMaterial.bind(this)} updateStatusElem={this.updateMaterialStatus.bind(this)} setEditingMode={this.setEditingMode.bind(this)} formEditing={this.state.editionMode} shouldRender={this.state.activeTab === index.toString()} />,
                "MATERIAL_INFO": <ShowDetails id={this.state.curMaterialId} type="material" genRef={this.materialGen} data={this.state.curMaterial} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={materialModel} modelsList={this.materialModels} loadElem={this.loadMaterial.bind(this)} saveElem={this.contextSaveMaterial.bind(this)} removeElem={this.removeMaterial.bind(this)} updateStatusElem={this.updateMaterialStatus.bind(this)} setEditingMode={this.setEditingMode.bind(this)} formEditing={this.state.editionMode} shouldRender={this.state.activeTab === index.toString()} manageBackMatTicket={this.manageBackMatTicket.bind(this)} />,
                "CONTACTS": <ShowDetails id={this.state.curMaterialId} type="materialContacts" data={this.state.curMaterial} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.materialModels ? this.materialModels["CONTACTS"] : {}} modelsList={this.materialModels} shouldRender={this.state.activeTab === index.toString()} />,
                "FILES": <Form id="frmaupdact3">
                    <FilesCustom className="material-files" bindID={this.state.curMaterialId} rightType={template?.checkRights?.entity} checkRights={this.props.checkRights} fileTypeID="MATERIAL" src={this.state.curMaterial}
                        srcName={this.state.curMaterial ? this.state.curMaterial.title : ""} withFilters={true} shouldRender={this.state.activeTab === index.toString()} defaultFileType={"TEC"}
                        altFilesTypes="../api/material/GetMaterialFilesType" altFilesUrl="../api/material/GetMaterialFiles" altRemoveFilesUrl="../api/material/RemoveMaterialFile" altUploadFilesUrl="../api/material/UploadMaterialFiles" />
                </Form>,
                "FLOWS": <Row className="material-history">
                    <Col lg="12">
                        <Card className="widget dash">
                            <CardHeader>
                                <CardTitle tag="h6">{context.props.i18nManager.t("material.flowsTitle")}</CardTitle>
                                <div className="widget-tools collapse-tool">
                                    <i className="fa fa-history fa-4x"></i>
                                </div>
                                <div className='borderTheme'></div>
                            </CardHeader>
                            <CardBody>
                                <Historical type="material" elemId={context.state.curMaterialId} rows={context.state.curMaterial?.flows} url="../api/material/GetMaterialFlows" getRoutes={context.props.getRoutes} shouldRender={context.state.activeTab === index.toString()} />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>,
            };

            return <TabPane key={"tabpane" + template.subType + index} tabId={index.toString()}>{this.props.checkRights(template?.checkRights?.entity, template?.checkRights?.rights) ? cptSysCollection[template.subType] : ""}</TabPane>;
        };

        //console.debug("render again");

        let contents = this.state.loading ? <p><em>{context.props.i18nManager.t("gal_loading")}</em></p> :
            <div>
                {this.materialModels && !this.state.noTable ? <CDataTable key="materials" dtId={"tableMaterials"} data={this.state.materials} localConfig={dtConfig} tag={tableConfig} config={this.materialModels[tableConfig]} stamp={this.state.dataStamp} functionPanel={this.dtFunctionPanel.bind(this)}
                    className="table-striped table-hover nowrap" style={{ fontSize: "90%" }} /> : ""}
            </div>;

        return (
            <div className="tableDetails">
                <Card className={`tableContainer widget dash ${this.state.editionMode ? "module-disabled" : ""}`}>
                    <CardHeader>
                        <CardTitle tag="h6">{context.props.i18nManager.t("material.title")}</CardTitle>
                        <div className="widget-tools collapse-tool">
                            <i className="fa fa-table-list fa-4x"></i>
                        </div>
                        <div className='borderTheme'></div>
                    </CardHeader>
                    <CardBody>
                        <div className="float-start">
                            <Button className="btn-rotate px-2 btn-simple mt-0" disabled={this.state.editionMode} color="dark" size="sm" onClick={() => this.getMaterials()}>
                                <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh")}
                            </Button>
                            {pageConfig?.templates?.map((template, index) => {
                                if (template.objType === "button" && this.props.checkRights(template.checkRights?.entity, template.checkRights.rights)) {
                                    switch (template.subType) {
                                        case "ADD":
                                            return <Button key={"addbtn"} className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" size="sm" onClick={() => this.initCreateMaterial()}>
                                                <i className="fa fa-plus-square fa-lg"></i>{context.props.i18nManager.t("material.add")}
                                            </Button>;
                                        default: return "";
                                    }
                                }
                                else return "";
                            })}
                        </div>
                        <CNavbar className="float-end">
                            <div className="text-end">
                                {this.state.status.map((dt) => {

                                    //TODO : statusBtnAltProc

                                    var statusClass = "form-badge-radio mb-1 ";
                                    statusClass += dt.css ? dt.css.replace("fa-", "untrigger") : "";
                                    return dt.isSchedulable ? <div id={`st_${dt.idStatus}`} key={dt.idStatus} className={statusClass}>
                                        <div className='form-check-radio fcheck-sm mb-0'>
                                            <Label check >
                                                <Input id={`status_${dt.idStatus}`} name={"status"} disabled={this.state.editionMode} checked={dt.idStatus === context.state.curStatus} type="radio" data-lvlv={dt.step} value={dt.idStatus} onChange={(e) => {
                                                    var value = parseInt(e.target.value);

                                                    context.setState({ curStatus: value, curMaterialId: 0, curMaterial: null, isShowDetails: false });
                                                }} />
                                                <span className="form-check-sign" />
                                                {(() => {
                                                    var classFa = "";
                                                    if (dt.css && dt.css.indexOf("fa-")) {
                                                        dt.css.split(" ").forEach((classElem) => {
                                                            //console.debug(classElem.startsWith("fa-") + classElem);
                                                            classFa += (classElem.startsWith("fa-") ? (classElem + " ") : "");
                                                        });
                                                    }
                                                    return <i className={`fa ${classFa} me-1`}></i>
                                                })()}
                                                {altT(dt.name)}
                                            </Label>
                                        </div>
                                    </div> : "";
                                })}
                            </div>
                        </CNavbar>
                        {contents}
                    </CardBody>
                </Card>

                {this.state.isShowDetails ? (<div className="detailsContainer">
                    <Card className="widget dash text-white" color="theme">
                        <CardHeader>
                            <Row>
                                <Col lg="10" className="offset-lg-1">
                                    <CardTitle tag="h6" className="text-center">
                                        {this.state.title}
                                    </CardTitle>
                                </Col>
                                <Col lg="1" className="d-flex text-end float-end justify-content-end">
                                    <Button className="btn btn-icon my-0 text-dark" color="light" id="selActPrev" type="button" disabled={this.state.editionMode} onClick={() => {
                                        var prevId = context.state.curMaterialId || 0;
                                        showDtPrevID("tableMaterials", prevId);
                                    }}><i aria-hidden="true" className="fa fa-arrow-circle-left"></i></Button>
                                    <Button className="btn btn-icon my-0 text-dark" color="light" id="selActNext" type="button" disabled={this.state.editionMode} onClick={() => {
                                        var prevId = context.state.curMaterialId || 0;
                                        showDtNextID("tableMaterials", prevId);
                                    }}><i aria-hidden="true" className="fa fa-arrow-circle-right"></i></Button>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Nav pills className={`${this.state.editionMode ? "invisible" : ""}`}>
                                {pageConfig?.templates?.filter(template => template.objType === "template").map((template, index) => (this.props.checkRights(template.checkRights?.entity, template.checkRights.rights) ? <NavItem key={"navItem" + index}><NavLink className={`${this.state.activeTab === (index + 1).toString() ? "active" : ""}`} onClick={() => { this.switchTab((index + 1).toString()) }}>{altT(template.title)}</NavLink></NavItem> : ""))}
                            </Nav>
                        </CardBody>
                    </Card>
                    <TabContent activeTab={this.state.activeTab}>
                        {pageConfig?.templates?.filter(template => template.objType === "template").map((template, index) => this.props.checkRights(template.checkRights?.entity, template.checkRights.rights) ? getSysCpt(template, index + 1) : "")}
                    </TabContent></div>) : ""}
            </div>
        );
    }

    async getMaterials(statusId, forcedUpdate, callback) {
        if (!forcedUpdate && this.state.editionMode) return;
        this.setState({ materials: [], curMaterialId: 0, curMaterial: null/*, loading: true*/, dataStamp: 0, isShowDetails: false, editionMode: false, noTable: false });
        var context = this;

        if (callback) {
            context.refreshCb = callback;
        }

        Swal.fire({
            title: context.props.i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var args = {};
        args.state = statusId || this.state.curStatus || 4000;
        if (context.state.pageModels === "INFO") {
            args.level = 5;
        }
        else args.level = 1;


        if (context.state.categoryGroupKey) args.categoryGroupKey = context.state.categoryGroupKey;

        commonFunc.getMethod("../api/material/GetMaterials", args).then((response) => {
            if (response.data) {
                if (response.data.isSuccess) {
                    Swal.close();
                    context.setState({ materials: response.data.result, loading: false, dataStamp: new Date().getTime(), isShowDetails: false });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_error"),
                        html: context.props.i18nManager.t("material.failLoadMaterials") + " :<br>" + response.data.errorMessage
                    });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_error"),
                    html: context.props.i18nManager.t("material.failLoadMaterials")
                });
            }
        });

    }

    loadStatusBtnGrp(defaultID) {
        var context = this;

        commonFunc.getMethod("../api/material/GetStatus", null).then((response) => {
            var data = response.data;

            //Libelle = name + ForeColor = foreColor + Opacite >> removed + Niveau = step + Categ = categ + Actif = isActive + Planifiable = isSchedulable + css + valeur = value
            if (data.isSuccess) {

                context.setState({ status: data.result, defaultStatus: defaultID });

            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_failLoadStatus") + "<br/>" + response.data.errorMessage
                });
            }

        });
    }

    async loadMaterial(id) {
        var context = this;

        var callback = this.loadReportCb;

        this.setState({ title: context.props.i18nManager.t("material.noSelected"), curMaterialId: 0, curMaterial: null, isShowDetails: (id > 0), editionMode: false });

        return new Promise((resolve, reject) => {

            var args = {};
            //args.state = 201;
            args.id = id;
            this.loadReportCb = null;

            if (context.state.pageModels === "INFO") {
                args.level = 3;
            }
            if (parseInt(id) > 0) {
                Swal.fire({
                    title: context.props.i18nManager.t("gal_loading"),
                    didOpen: () => { Swal.showLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false
                });

                commonFunc.getMethod("../api/material/GetMaterial", args).then((response) => {
                    var data = response.data;
                    if (data.isSuccess) {
                        console.log(data.result);

                        if (callback && typeof (callback) === "function") { callback(data); }

                        Swal.close();

                        if (context.state.isShowDetails) context.setState({ title: ("[" + (data.result.category ? data.result.category.name : "") + "] " + data.result.name + " • " + data.result.model), curMaterialId: id, curMaterial: data.result, isShowDetails: true });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: context.props.i18nManager.t("gal_error"),
                            html: context.props.i18nManager.t("material.failLoadMaterial") + " :<br>" + data.errorMessage
                        });
                    }
                    resolve(data);
                });

            }
            else {
                resolve({ isSuccess: true, result: "" });
            }
        });
    }

    async contextSaveMaterial(userMaterial, isUpdate) {
        var context = this;

        return saveMaterial(userMaterial, context.state.curMaterial, isUpdate, { translation: context.props.i18nManager.t }).then((materialResponse) => {
            context.loadMaterial(materialResponse.idMaterial);//userMaterial.idMaterial

            return new Promise((resolve, reject) => {
                resolve(materialResponse);
            });
        });
    }

    removeMaterial(id, title) {
        var context = this;
        return new Promise((resolve, reject) => {
            var row = context.state.curMaterial;
            if ((!id && row) || (id && row && id === row.idMaterial)) {
                id = id || row.idMaterial;
                title = row.name;
            }
            if (parseInt(id) > 0) {
                Swal.fire({
                    icon: "question",
                    title: context.props.i18nManager.t("gal_removing"),
                    html: context.props.i18nManager.t("material.rmvTitle") + "<br/>[" + id + "] " + title,
                    showCancelButton: true,
                    confirmButtonColor: "#28a745",
                    cancelButtonColor: "#dc3545",
                    confirmButtonText: context.props.i18nManager.t("gal_yes"),
                    cancelButtonText: context.props.i18nManager.t("gal_no"),
                }).then((result) => {
                    if (result.value) {
                        Swal.fire({
                            title: context.props.i18nManager.t("material.removing"),
                            didOpen: () => { Swal.showLoading() }
                        });
                        var req = { id: id, isPermanent: false };
                        commonFunc.postMethod("../api/material/RemoveMaterial", req).then((response) => {
                            Swal.close();
                            var data = response.data;
                            if (data && data.isSuccess) {
                                context.getMaterials();//TODO : check si besoin de refresh supplémentaire
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: context.props.i18nManager.t("gal_fail"),
                                    html: context.props.i18nManager.t("gal_errorRmv") + "<br/>" + response.data.errorMessage
                                });
                            }
                            resolve(data);
                        });

                    }
                    else {
                        resolve({ isSuccess: true, result: "" });
                    }
                });
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_noSelectedElem")
                });
                resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_noSelectedElem") });
            }
        });
    }


    updateMaterialStatus(statusId, stepId, customLabel, reloadMaterial, noSwal) {
        var context = this;
        return new Promise((resolve, reject) => {
            var id = context.state.curMaterialId;
            if (parseInt(id) > 0) {
                if (statusId > 0) {
                    var label = "";
                    reloadMaterial = (reloadMaterial === false ? false : true);

                    var curStatus = context.state.status.filter((status) => status.idStatus === statusId);
                    label = customLabel || (curStatus.length ? curStatus[0].name : "");


                    var statusProc = () => {
                        Swal.fire({
                            title: context.props.i18nManager.t("material.updatingStatus"),
                            didOpen: () => { Swal.showLoading() },
                        });
                        var req = { id: id, newStatus: statusId, newStep: stepId || -1 };

                        commonFunc.postMethod("../api/material/UpdateStatus", req).then((response) => {

                            Swal.close();
                            if (response.data && response.data.isSuccess) {
                                /*context.getMaterials(0, true, () => {
                                    if (reloadMaterial) showDtSelID("tableMaterials", id);
                                });*///TODO : check si besoin de refresh supplémentaire
                                if (reloadMaterial) context.loadMaterial(id);
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: context.props.i18nManager.t("gal_fail"),
                                    html: context.props.i18nManager.t("gal_failUpdStatus") + "<br/>" + response.data.errorMessage
                                });
                            }
                            resolve(response.data);
                        });
                    };

                    if (noSwal) {
                        statusProc();
                    }
                    else {
                        Swal.fire({
                            icon: "question",
                            title: context.props.i18nManager.t("material.updStatus"),
                            html: context.props.i18nManager.t("material.statusAs", [label]),
                            showCancelButton: true,
                            confirmButtonColor: "#28a745",
                            cancelButtonColor: "#dc3545",
                            confirmButtonText: context.props.i18nManager.t("gal_yes"),
                            cancelButtonText: context.props.i18nManager.t("gal_no"),
                        }).then((result) => {
                            if (result.value) {
                                statusProc();
                            }
                            else {
                                resolve({ isSuccess: true, result: "" });
                            }
                        });
                    }
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_invalidStatus")
                    });
                    resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_invalidStatus") });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_noSelectedElem")
                });
                resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_noSelectedElem") });
            }
        });
    }

    manageBackMatTicket(statusID, stepID, defaultAssign, defaultTicket, altMode) {
        var context = this;
        var altMaterial = Object.assign({}, this.state.curMaterial);

        //Vérification présence assignment matériel
        var mtnAssign = altMaterial.materialAssigns?.filter(assign => assign.service?.refExtID === "608" && assign.statusExt === "EC" && assign.endDate === "2099-12-31");

        var swalSuccess = () => {
            Swal.fire({
                icon: "success",
                title: context.props.i18nManager.t("gal_success"),
                html: context.props.i18nManager.t("gal_successUpd"),
                didOpen: () => { Swal.hideLoading() },
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                timer: 2000,
            }).then(() => {
                context.loadMaterial(altMaterial.idMaterial);//userMaterial.idMaterial
            });
        };

        //Restauration parc
        if (!defaultAssign && !defaultTicket) {
            if (mtnAssign?.length) {
                mtnAssign[0].endDate = new Date().toISOString().substring(0, 10);
                mtnAssign[0].statusExt = "KO";
            }

            if (altMode?.startsWith("clear")) {
                var split = altMode.split(":");
                altMaterial.cAssignments = true;
                altMaterial.assignEmployeeID = -1;//null
                altMaterial.assignSiteID = (split.length > 1 ? parseInt(split[1]) : -1);//null
                /*if (mtnAssign.length <= 0) {
                    Swal.fire({
                        icon: "warning",
                        title: context.props.i18nManager.t("gal_warning"),
                        html: "Aucune assignation maintenance est en cours"
                    });
                    return;
                }*/
            }

            altMaterial.statusID = statusID;
            altMaterial.stepID = stepID;

            saveMaterial(altMaterial, context.state.curMaterial, true, { translation: context.props.i18nManager.t, noSwal: true }).then((responseMaterial) => {
                if (responseMaterial?.idResponse) {
                    //Clôture du ticket
                    if (mtnAssign?.length) {
                        var args = {};
                        args.state = 7000;
                        args.materialID = altMaterial.idMaterial;
                        //args.level = 3;

                        commonFunc.getMethod("../api/ticket/GetTickets", args).then((response) => {
                            var data = response.data;
                            if (data.isSuccess) {
                                console.log(data.result);

                                var currentTickets = data.result.filter(ticket => ticket.status.step < 3 && ticket.extRef === "MATMTN-" + mtnAssign[0].idAssign);
                                if (currentTickets?.length) {
                                    console.debug(currentTickets);
                                    //MAJ Ticket Associé
                                    var backTicket = currentTickets[0];
                                    backTicket.endDate = new Date().toISOString();
                                    backTicket.closeComments = "Clôture via restitution manuelle depuis matériel";

                                    saveTicket(backTicket, null, true, { translation: context.props.i18nManager.t, noSwal: true }).then(responseTicket => {
                                        if (responseTicket?.idResponse) {
                                            console.debug("ISOK");
                                            var req = { id: backTicket.idTicket, newStatus: 7003, newStep: -1 };
                                            commonFunc.postMethod("../api/ticket/UpdateStatus", req).then((response) => {
                                                swalSuccess();
                                            });
                                        }
                                    });
                                }
                                else {
                                    swalSuccess();
                                }
                                Swal.close();
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: context.props.i18nManager.t("gal_error"),
                                    html: context.props.i18nManager.t("material.failLoadMaterial") + " :<br>" + data.errorMessage
                                });
                            }
                        });
                    }
                    else {
                        swalSuccess();
                    }
                }
            });
        }
        //Retour pour maintenance
        else {
            if (mtnAssign?.length) {
                Swal.fire({
                    icon: "warning",
                    title: context.props.i18nManager.t("gal_warning"),
                    html: "Une assignation maintenance est en cours"
                });
                return;
            }

            //Gestion Assignment
            var newAssign = defaultAssign || {};
            newAssign.startDate = new Date().toISOString().substring(0, 10);
            newAssign.assignEmployeeID = -1; //altMaterial.assignEmployeeID;
            newAssign.siteID = altMaterial.assignSiteID;

            if (!altMaterial.materialAssigns) altMaterial.materialAssigns = [];
            altMaterial.materialAssigns.push(newAssign);

            altMaterial.statusID = statusID;
            altMaterial.stepID = stepID;

            saveMaterial(altMaterial, context.state.curMaterial, true, { translation: context.props.i18nManager.t, noSwal: true }).then((responseMaterial) => {
                console.debug(responseMaterial);
                if (responseMaterial?.idResponse) {

                    //Récupération Assignation créé
                    var refExtID = 0;
                    var filteredMtnActive = responseMaterial.materialAssigns?.filter(assign => assign.serviceID === 608 && assign.statusExt === "EC" && assign.endDate === "2099-12-31");//pas de retour service?.refExtID du response
                    if (filteredMtnActive?.length) {
                        refExtID = filteredMtnActive[0].idAssign;
                    }

                    //Création Ticket Associé
                    var backTicket = defaultTicket || {};
                    //backTicket.address = { addressMain: "N/A", categ: "SITE", title: "Adresse" };//TODO : Adresse du site ?
                    backTicket.startDate = new Date().toISOString();
                    backTicket.extRef = "MATMTN-" + refExtID;
                    backTicket.title = "Retour Matériel - " + altMaterial.name;
                    backTicket.assignMaterialID = altMaterial.idMaterial;
                    backTicket.assignEmployeeID = -1;//altMaterial.assignEmployeeID
                    backTicket.assignSiteID = altMaterial.assignSiteID;
                    backTicket.comments = "Retour Fédé. - " + (altMaterial.intRef || "N/A") + " / " + (altMaterial.serialNumber || "N/A");

                    saveTicket(backTicket, null, false, { translation: context.props.i18nManager.t, noSwal: true }).then(responseTicket => {
                        if (responseTicket?.idResponse) {
                            console.debug("ISOK");
                            swalSuccess();
                        }
                        else {
                            //TODO : remove Assign + change status ??
                        }
                    });
                }
            });
        }
    }

    initCreateMaterial() {
        if (this.state.editionMode) return;
        setDtNoSelect("tableMaterials");
        //this.materialGen.current.resetForm();
        this.setState({ title: this.props.i18nManager.t("material.create"), curMaterialId: 0, curMaterial: null, isShowDetails: false, editionMode: true, activeTab: "1" });
    }

    switchTab(numTab, entity) {
        if (this.state.editionMode) return;
        this.setState({ activeTab: numTab })
    }

    setEditingMode(value, isDuplicate) {
        var title = this.state.curMaterial ? this.state.curMaterial.title : "";
        this.setState({ title: (isDuplicate ? this.props.i18nManager.t("material.duplicate") : this.props.i18nManager.t("material.edit")) + " - " + title, editionMode: value });
    }
}

const withI18n = (Component) => {
    return props => {
        const i18n = useTranslation();
        return <Component {...props} i18nManager={{ ...i18n }} />
    }
}

export default withRouter(withI18n(ManageMaterials));

        

export async function saveMaterial(userMaterial, dataMaterial, isUpdate, args) {
    dataMaterial = dataMaterial || {};

    Swal.fire({
        title: args.translation("gal_saving"),
        didOpen: () => { Swal.showLoading() },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
    });


    if (!userMaterial.avoidMerge) {
        userMaterial = commonFunc.mergeDeep({}, dataMaterial, userMaterial);

        userMaterial.accountUser = null;
        userMaterial.category = null;
        userMaterial.parent = null;
        userMaterial.client = null;
        userMaterial.report = null;
        userMaterial.manager = null;
        userMaterial.employee = null;
        userMaterial.provider = null;
        userMaterial.group = null;
        userMaterial.site = null;
        userMaterial.extSite = null;
        userMaterial.extraSite = null;
        userMaterial.status = null;
        userMaterial.subStatus = null;
        userMaterial.tenantUserAccess = null;
    }

    if (userMaterial.materialAssigns?.length) {
        userMaterial.materialAssigns.forEach(assign => {
            assign.client = null;
            assign.employee = null;
            assign.service = null;
            assign.site = null;
        });
    }

    var manageAssign = userMaterial.idMaterial === 0;
    if (userMaterial.cAssignments) {
        //Gestion Assignment Employee
        if (userMaterial.assignEmployeeID !== dataMaterial.assignEmployeeID) {
            manageAssign = true;
        }
        //Gestion Assignment Agence
        if (userMaterial.assignSiteID !== dataMaterial.assignSiteID) {
            manageAssign = true;
        }

        if (manageAssign) {
            if (userMaterial.idMaterial > 0) {
                //userMaterial.materialAssigns = null;
                if (userMaterial.materialAssigns?.length) {
                    var filteredAssigns = userMaterial.materialAssigns.filter(assign => assign.serviceID === -1 && assign.statusExt === "OK" && assign.endDate === "2099-12-31").sort((a, b) => {
                        return moment(a.endDate).diff(b.endDate, "days");
                    });

                    if (filteredAssigns?.length) {
                        filteredAssigns[0].endDate = new Date().toISOString().substring(0, 10);
                        filteredAssigns[0].statusExt = "FIN";
                    }
                }

                var newAssign = {};
                newAssign.idAssign = 0;
                newAssign.parentID = null;
                newAssign.materialID = userMaterial.idMaterial;
                newAssign.material = null;
                newAssign.title = "Assignation Matériel";
                newAssign.startDate = new Date().toISOString().substring(0, 10);
                newAssign.endDate = "2099-12-31T00:00:00.000Z".substring(0, 10);
                newAssign.statusExt = "OK";
                newAssign.assignEmployeeID = userMaterial.assignEmployeeID;
                newAssign.employee = null;
                newAssign.siteID = userMaterial.assignSiteID;
                newAssign.site = null;

                if (!userMaterial.materialAssigns) userMaterial.materialAssigns = [];
                userMaterial.materialAssigns.push(newAssign);
            }
            else {
                var newAssign = {};
                newAssign.idAssign = 0;
                newAssign.parentID = null;
                newAssign.materialID = 0;
                newAssign.material = null;
                newAssign.title = "Assignation Matériel";
                newAssign.startDate = new Date().toISOString().substring(0, 10);
                newAssign.endDate = "2099-12-31T00:00:00.000Z".substring(0, 10);
                newAssign.statusExt = "OK";
                newAssign.assignEmployeeID = userMaterial.assignEmployeeID;
                newAssign.employee = null;
                newAssign.siteID = userMaterial.assignSiteID;
                newAssign.site = null;

                if (!userMaterial.materialAssigns) userMaterial.materialAssigns = [];
                userMaterial.materialAssigns.push(newAssign);
            }
        }
    }

    console.debug(userMaterial);
    //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
    return commonFunc.postMethod(isUpdate ? "../api/material/UpdateMaterial" : "../api/material/CreateMaterial", userMaterial).then((response) => {
        Swal.close();
        return new Promise((resolve, reject) => {
            var data = response.data;
            if (data && data.isSuccess) {

                var nextProc = () => {
                    /*if (context.state.curStatus !== data.result.statusID) {
                        context.setState({ curStatus: data.result.statusID });
                        context.refreshCb = () => {
                            showDtSelID("tableMaterials", data.result.idMaterial);
                        };
                    }
                    else {
                        context.getMaterials(0, true, () => {
                            showDtSelID("tableMaterials", data.result.idMaterial);
                        });
                    }*/

                    data.result.idResponse = data.result.idMaterial;
                    resolve(data.result);
                };


                if (args.noSwal) {
                    nextProc();
                }
                else {
                    Swal.fire({
                        icon: "success",
                        title: args.translation("gal_success"),
                        html: (isUpdate ? args.translation("gal_successUpd") : args.translation("gal_successAdd")),
                        didOpen: () => { Swal.hideLoading() },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                    }).then((result) => {
                        nextProc();
                    });
                }

            } else {
                var supErrors = "";
                if (data.errors && data.errors.length) {
                    supErrors = data.errors.map((error) => {
                        return "<br>" + error.desc + "(" + error.value + ")";
                    });
                }
                Swal.fire({
                    icon: "error",
                    title: args.translation("gal_fail"),
                    html: args.translation("gal_errorSave") + " :<br>" + data.errorMessage + supErrors
                });
                resolve(data);
            }
        });
    });
}